import React, { Component } from 'react';
import {} from './style/modal.css';

export default class Modal extends Component {
	constructor(props) {
		super(props);
		//state
		this.state = {
			isOpen: false
		};
		this.onClose = this.onClose.bind(this);

		this.onClick = this.onClick.bind(this);
	}
	onClose() {
		if (this.props.onClose) {
			this.props.onClose();
		}
	}

	onClick() {
        var {project} = this.props;
		if(project)
        if(project.link){
            if(project.link.external){ //open a new page
                var url = project.link.url
                var win = window.open(url, '_blank');
                win.focus();
            }else{
                //load react routers
            }
            
        }
        

    }
	render() {
		var { isOpen, project } = this.props;

		if (!isOpen) return null;
		//else
		return (
			<div className="modal-container">
				<div className="modal">
					<div className="modal-title">{project.title.toString().toUpperCase()}</div>
					<div className="modal-title-divider" />
					<div className="modal-type">{project.type}</div>
					<div className="modal-year">{project.year}</div>

					<div className="modal-text">{project.details}</div>
					{project.link ? (
						<div className="modal-link-container">
							<div className="modal-link-line" />
							<div className="modal-link" onClick={this.onClick}>
								open project page
							</div>
						</div>
					) : null}

					<div className="modal-close" onClick={this.onClose}>
						close
					</div>
					<div className="modal-close-line" />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Modal.js